<template>
    <div class="col d-flex align-items-center justify-content-center">
        <button type="button" class="btn btn-link c-blue btn--query" @click="getDetails" v-if="showQueryBtn">{{ getWtpCharge }}</button>
        <div class="d-inline-block loader" v-if="loading">
            <icon-base :view-box-height="50"
                       :view-box-width="50"
                       :min-width="0"
                       :min-height="0"
                       :icon-color="'#166ba6'"
                       :height="30"
                       :width="30" :class="'align-bottom'">
                <loading-icon/>
            </icon-base>
        </div>
        <div v-if="charge" v-text="charge"></div>
    </div>
</template>

<script>
    import API from '../api';

    export default {
        props: {
            cardId: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                getWtpCharge: Valle.translations.consultarCarga,
                charge: '',
                loading: false
            }
        },

        methods: {
            getDetails() {
                this.loading = true;

                API.card.get({id: this.cardId}).then(({detail}) => {
                    this.loading = false;
                    this.charge = detail;
                });
            }
        },

        computed: {
            showQueryBtn() {
                return ! this.loading && ! this.charge;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/WtpCardDetails.vue